export enum SortDirection {
	DESC = 'Descending',
	ASC = 'Ascending'
}

export interface SortingParams {
	field: string
	order: SortDirection
}

export interface PaginationParams {
	pageNumber?: number
	pageSize?: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface TableUrlParams extends Record<string, any> {
	pageSize?: number
	page?: number
	sortOrder?: SortDirection
	sortField?: string
	query?: string
}
